export * from '@material-ui/icons';
export { AutoModeOutlined } from './icons/AutoModeOutlined';
export { RocketLaunchOutlined } from './icons/RocketLaunchOutlined';
export { EditNoteOutlined } from './icons/EditNoteOutlined';
export { GoldCustomer } from './icons/GoldCustomer';
export { GoldCustomerOutlined } from './icons/GoldCustomerOutlined';
export { Inventory2 } from './icons/Inventory2';
export { Inventory2Outlined } from './icons/Inventory2Outlined';
export { ManageSearchOutlined } from './icons/ManageSearchOutlined';
export { PaymentsOutlined } from './icons/PaymentsOutlined';
export { PsychologyAlt } from './icons/PsychologyAlt';
export { PsychologyAltOutlined } from './icons/PsychologyAltOutlined';
export { MagaluEntregasOutlined } from './icons/MagaluEntregasOutlined';
